import { render, staticRenderFns } from "./product-card-liste-view.vue?vue&type=template&id=4115e4c7&scoped=true&"
import script from "./product-card-liste-view.vue?vue&type=script&lang=js&"
export * from "./product-card-liste-view.vue?vue&type=script&lang=js&"
import style0 from "./product-card-liste-view.vue?vue&type=style&index=0&id=4115e4c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4115e4c7",
  null
  
)

export default component.exports